export const lang = {
    hu: {
        title: "VIKI Konferencia rendszer - online behívás",
        testRoomText: "A csatlakozás gombra kattintva Ön egy interaktív teszt szobához fog csatlakozni, ahol 20 másodpercen keresztül ellenőrizheti önállóan a készüléke (böngésző) és internet kapcsolatának megfelelőségét, hogy milyen videó és hang minőséggel tud csatlakozni.",
        joinBtn: "Csatlakozás",
        NoAvailableCoSpace: "Jelenleg nincs elérhető teszt szoba. Kérjük próbálja meg később.",
        Loading: "Betöltés...",
        LicenseExpired: "WebRTC licensz lejárt!",
        ConferenceNotAvail: "A konferencia nem elérhető",
        CannotConnectToConf: "Konferenciához való csatlakozás nem engedélyezett.",
        ConferenceIsLocked: "Konferencia jellege: zárolt.",
        ConferenceIsPrivate: "Konferencia jellege: privát.",
        ConferenceHasStarted: "A konferencia elkezdődött.",
        ConferenceHasEnded: "A konferencia véget ért.",
        ConferenceIsConflicted: "Konferencia ill. Távmeghallgatás megnyitása csúszik, mert az előző még nem fejeződött be, kérjük várakozzon türelemmel.",
        WaitingForLogin: "Várakozás beléptetésre...",
        RedirectBySupervisor: "Amint a meghallgató által beléptetésre kerül, automatikusan átirányítjuk a bejelentkező felületre...",
        Redirect: "Automatikusan átirányítjuk a bejelentkező felületre...",
        RedirectSoon: "A konferencia kezdetekor automatikusan átirányítjuk a bejelentkező felületre...",
        ConferenceSoonBegins: "A konferencia 5 percen belül kezdődik.",
        Maintenance: "Karbantartás alatt, köszönjük a türelmét!",
        LoginText: "Ha Ön már regisztrált felhasználónk, akkor itt bejelentkezhet vagy lépjen be vendégként:",
        LoginBtn: "Bejelentkezés",
        LogoutBtn: "Kijelentkezés",
        ContinueAsGuest: "Folytatás vendégként",
        RateTestCall: "Kérjük értékelje a teszt hívást.",
        Submit: "Beküldés",
        RateSuccessful: "Köszönjük az értékelést!",
        RateFailed: "A hívás már értékelve volt, köszönjük!",
        NewSystemMessage: "Új rendszerüzenet!",
        Author: "Szerző:",
        Category: "Kategória:",
        IUnderstand: "Értem.",
        TrialStateisNone: "A konferencia jelenleg nem aktív! A szervező még nem nyitotta meg vagy már lezárta a konferenciát. Ha a kapott konferencia időponton belül van, akkor kérjük ismételje meg kis idő elteltével a kapcsolódást, az eredetileg kapott link használatával.",
        TrialStateisNoneAndConflicted: "A konferencia jelenleg nem aktív! Résztvevő ill. időpont ütközés alakult ki, ami miatt csúszás várható. Kérjük türelmét és 5 percenként próbálja újra a kapcsolódást, az eredetileg kapott link használatával."
    },
    en: {
        title: "VIKI Conference system - online call",
        testRoomText: "By clicking the connect button, you will be connected to an interactive test room, where you can check for 20 seconds whether your device (browser) Internet connection, video and sound quality are sufficient enough.",
        joinBtn: "Connect",
        NoAvailableCoSpace: "No available test room at the moment. Please try again later.",
        Loading: "Loading...",
        LicenseExpired: "WebRTC license has expired!",
        ConferenceNotAvail: "Conference is not available.",
        CannotConnectToConf: "Connection to this conference is not allowed.",
        ConferenceIsLocked: "This conference is locked.",
        ConferenceIsPrivate: "This conference is private.",
        ConferenceHasStarted: "Conference has started.",
        ConferenceHasEnded: "Conference has ended.",
        ConferenceIsConflicted: "The current conference or remote hearing conference is delayed, because a previous conference is still ongoing, please wait patiently.",
        WaitingForLogin: "Waiting for login...",
        RedirectBySupervisor: "As soon as the supervisor allows it, you will be automatically redirected to the login page...",
        Redirect: "Redirecting to the login page...",
        RedirectSoon: "When the conference begins you will be automatically redirected to the login page...",
        ConferenceSoonBegins: "Conference will start in 5 minutes.",
        Maintenance: "Under maintenance, thank you for your patience!",
        LoginText: "You can login here, if you have already registered or join as guest:",
        LoginBtn: "Login",
        LogoutBtn: "Logout",
        ContinueAsGuest: "Continue as guest",
        RateTestCall: "Please rate your test call.",
        Submit: "Submit",
        RateSuccessful: "Thank you for your review!",
        RateFailed: "Rating has been submitted already, thank you!",
        NewSystemMessage: "New system message!",
        Author: "Author:",
        Category: "Category:",
        IUnderstand: "I understand.",
        TrialStateisNone: "The conference is currently inactive! The organizer has not yet opened or has already closed the conference. If you are within the scheduled conference time, please try reconnecting after a short wait using the original link provided.",
        TrialStateisNoneAndConflicted: "The conference is currently inactive! A participant or scheduling conflict has arisen, causing a delay. Please be patient and try reconnecting every 5 minutes using the original link provided."

    }
}
